import type { SchemaRegion } from "../../../api/restaurantSchema";

// Страницата „Схема на заведението" и гейтовете на route-а ѝ в main.tsx:
// ролята на модула „Резервации" + правото на самата страница.
export const SCHEMA_PAGE_PATH = "/reservations/restaurant-schema";
const RESERVATIONS_ROLE = "reservations";
const SCHEMA_PERMISSION = "manage_restaurant_schema";

interface NamedGrant {
  name: string;
}

/** Може ли потребителят да отвори „Схема на заведението" — същата проверка като route-а ѝ. */
export const canOpenSchemaPage = ({ roles, permissions }: { roles: NamedGrant[]; permissions: NamedGrant[] }) =>
  roles.some((role) => role.name === RESERVATIONS_ROLE) &&
  permissions.some((permission) => permission.name === SCHEMA_PERMISSION);

/** Може ли празен екран да води към схемата: право за страницата и не срещу касата (там схемата не се редактира). */
export const canLinkToSchema = ({ canOpenSchema, isEdgeLocal }: { canOpenSchema: boolean; isEdgeLocal: boolean }) =>
  canOpenSchema && !isEdgeLocal;

/** Районът е без нито една маса (обектите не се броят — резервации се правят само върху маси). */
export const hasNoTables = (region: SchemaRegion) => !region.elements.some((element) => element.kind === "table");

/**
 * Празният екран „Към схемата на заведението" вместо цялата страница: само
 * при заредена схема без НИТО ЕДНА маса, с линк към схемата. Празен район до
 * район с маси е в самото платно/таблица (`SchemaSetupNotice scope="region"`).
 * Без право — екранът е както досега.
 */
export const showsSchemaSetup = ({
  regions,
  canOpenSchema,
  isEdgeLocal,
}: {
  regions: SchemaRegion[] | undefined;
  canOpenSchema: boolean;
  isEdgeLocal: boolean;
}) =>
  regions !== undefined && canLinkToSchema({ canOpenSchema, isEdgeLocal }) && regions.every(hasNoTables);
